import { Root } from './wrapRootElement'

export const wrapRootElement = Root
